import { render } from "./BankBalance.vue?vue&type=template&id=3c549578"
import script from "./BankBalance.vue?vue&type=script&lang=js"
export * from "./BankBalance.vue?vue&type=script&lang=js"

import "./BankBalance.vue?vue&type=style&index=0&id=3c549578&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__